export const UserMenus = [
  {
    label: "Dashboard",
    key: "dashboard",
    icon: "ki-outline ki-element-11",
  },
  // {
  //   label: "Dashboard V2",
  //   key: "dashboard-v2",
  //   icon: "ki-outline ki-element-11",
  // },
  {
    label: "AI Copilot",
    key: "ai-copilot",
    icon: "ki-outline ki-abstract-26",
    beta: true,
  },

  {
    label: "Alerts",
    key: "alerts",
    icon: "ki-outline ki-notification-on",
  },

  {
    label: "Products",
    key: "settings/products",
    icon: "ki-outline ki-directbox-default",
  },
  {
    label: "Expenses",
    key: "settings/expenses",
    icon: "ki-outline ki-finance-calculator",
  },
  {
    label: "Billing",
    key: "settings/billing",
    icon: "ki-outline ki-wallet",
  },
  {
    label: "Import & Export",
    key: "settings/file-manager",
    icon: "ki-outline ki-cloud-add",
  },

  {
    label: "Configurations",
    key: "settings",
    icon: "ki-outline ki-gear",
    // Keep configuration menu closed by default
    defaultOpen: false,
    closable: true,
    children: [
      {
        key: "settings/myprofile",
        label: "My Profile",
        isSubSection: true,
        className: "sidebar-submenu-item",
      },
      {
        key: "settings/marketplace-credentials",
        label: "Marketplace Credentials",
        isSubSection: true,
        className: "sidebar-submenu-item",
      },
      {
        key: "settings/advance-settings",
        label: "Advanced Settings",
        isSubSection: true,
        className: "sidebar-submenu-item",
      },
      // {
      //   key: "settings/manage-seller",
      //   label: "Manage Seller Accounts",
      //   icon: "ki-outline ki-people",
      //   isSubSection: true,
      //   className: "sidebar-submenu-item",
      //   iconClassName: "sidebar-submenu-icon",
      // },
    ],
  },
];
